import { HashStringUseCase } from '../Hash/HashString';
export class GenerateSymmetricAdditionalDataUseCase {
    constructor(crypto) {
        this.crypto = crypto;
        this.hashUseCase = new HashStringUseCase(this.crypto);
    }
    execute(payloadPlaintext, hashingKey, signingKeyPair) {
        const plaintextHash = this.hashUseCase.execute(payloadPlaintext, hashingKey);
        if (!signingKeyPair) {
            return {
                additionalData: {},
                plaintextHash,
            };
        }
        const signature = this.crypto.sodiumCryptoSign(plaintextHash, signingKeyPair.privateKey);
        return {
            additionalData: {
                signingData: {
                    publicKey: signingKeyPair.publicKey,
                    signature,
                },
            },
            plaintextHash,
        };
    }
}
